import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import ProgramFaqsPage from '@/features/programs/program-create-faqs/ProgramFaqsPage';

export const programCreateFaqsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/programas/novo/perguntas-frequentes',
  component: ProgramFaqsPage,
});
